import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API()

export default {

    wyslijDaneSprzedazyDoFK() {
        return axios({
            method: 'get',
            url: URL + 'bilety/wyslijSprzedazDoFK',
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/administracja/synchronizacjaDanych/SynchronizacjaService.js